module.exports = __webpack_public_path__ + "img/front.de55461d.svg";